module.exports = __webpack_public_path__ + "img/jb-2.0-upsell.524b3c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/jb-2.0-upsell.svg
// module id = anXk
// module chunks = 38 43